import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';
import { MdVisibility, MdVisibilityOff, MdEmail, MdLock } from 'react-icons/md';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success('Welcome back!');
      navigate('/');
    } catch (err) {
      if (err.response?.status === 401 || err.response?.status === 400) {
        toast.error('Invalid credentials. Please check your email and password and try again.');
      } else {
        toast.error(err.response?.data?.message || err.message || 'Login failed');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-split">
      <div className="login-video-col">
        <video
          className="login-video"
          src="https://bsapp.b-cdn.net/articles/videos/1a6116ed-acb8-4b7a-9af4-d253d8a58529-1784968526885.mp4"
          autoPlay
          loop
          muted
          playsInline
        />
        <div className="login-video-overlay" />
        <div className="login-video-logo">
          <img src="/login.png" alt="Udayam Digital" />
        </div>
      </div>

      <div className="login-form-col">
        <div className="login-card">
          <div className="login-logo-wrap">
            <img src="/login-logo.png" alt="Udayam Digital" className="login-logo" />
          </div>
          <div className="login-header">
            <p>Admin Panel Access</p>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Email</label>
              <div className="input-with-icon has-icon-left">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  required
                />
                <div className="input-icon-left"><MdEmail /></div>
              </div>
            </div>
            <div className="form-group">
              <label>Password</label>
              <div className="input-with-icon has-icon-left">
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  required
                />
                <div className="input-icon-left"><MdLock /></div>
                <button
                  type="button"
                  className="input-icon-btn"
                  onClick={() => setShowPassword(!showPassword)}
                  tabIndex={-1}
                >
                  {showPassword ? <MdVisibilityOff /> : <MdVisibility />}
                </button>
              </div>
            </div>
            <button type="submit" className="btn btn-primary btn-full" disabled={loading}>
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
